import { IGetRowsParams, GridApi } from 'ag-grid-community';
import { lastValueFrom } from 'rxjs';
import { AgGridDataSourceBase, AgGridDataSourceResult } from '../../../../AgGrid';
import { ReturnAssetsService } from '../returnAssets.service';
import { ReturnService } from '../../../return.service';
import { ReturnAssetRepository } from '../../../../Repositories';

export interface ReturnAssetDisposalsListDataSourceParams {
    priorReturnStatuses: Compliance.ReturnAssetPriorReturnStatusEnum[];
    formRevisionScheduleId: number;
    targetNonReportableSchedule: boolean;
    targetReportableSchedule: boolean;
    scheduleGroupType?: Compliance.ScheduleGroupTypeEnum;
}

export class ReturnAssetDisposalsListAgGridDataSource extends AgGridDataSourceBase<ReturnAssetDisposalsListDataSourceParams> {
    constructor(
        private _gridApi: GridApi,
        private _returnService: ReturnService,
        private _returnAssetsService: ReturnAssetsService,
        private _returnAssetRepository: ReturnAssetRepository,
        protected _dataSourceParamsFn: () => ReturnAssetDisposalsListDataSourceParams,
        private _totalsUpdateCallback: (totals: Compliance.ReturnAssetSearchTotalsModel) => void,
    ) {
        super(_gridApi);
    }

    private readonly _propertyMap: Compliance.NameValuePair<Compliance.ReturnAssetPropertyEnum>[] = [
        { name: 'assetNumber', value: Compliance.ReturnAssetPropertyEnum.AssetNumber },
        { name: 'description', value: Compliance.ReturnAssetPropertyEnum.Description },
        { name: 'classificationName', value: Compliance.ReturnAssetPropertyEnum.ClassificationName },
        { name: 'parcelAccountNumber', value: Compliance.ReturnAssetPropertyEnum.ParcelAccountNumber },
        { name: 'acqDate', value: Compliance.ReturnAssetPropertyEnum.AcqDate },
        { name: 'priorAcqDate', value: Compliance.ReturnAssetPropertyEnum.PriorAcqDate },
        { name: 'cost', value: Compliance.ReturnAssetPropertyEnum.Cost },
        { name: 'priorCost', value: Compliance.ReturnAssetPropertyEnum.PriorCost },
        { name: 'costChange', value: Compliance.ReturnAssetPropertyEnum.CostChange },
        { name: 'scheduleName', value: Compliance.ReturnAssetPropertyEnum.Schedule },
        { name: 'priorScheduleName', value: Compliance.ReturnAssetPropertyEnum.PriorSchedule },
        { name: 'depreciationFactorTableName', value: Compliance.ReturnAssetPropertyEnum.DepreciationFactorTableName },
        {
            name: 'priorDepreciationFactorTableName',
            value: Compliance.ReturnAssetPropertyEnum.PriorDepreciationFactorTableName,
        },
        { name: 'factor', value: Compliance.ReturnAssetPropertyEnum.Factor },
        { name: 'reportedValue', value: Compliance.ReturnAssetPropertyEnum.DepreciationCost },
        { name: 'disposedDate', value: Compliance.ReturnAssetPropertyEnum.DisposedDate },
        { name: 'site', value: Compliance.ReturnAssetPropertyEnum.Site },
        { name: 'siteName', value: Compliance.ReturnAssetPropertyEnum.SiteName },
        { name: 'siteProperty', value: Compliance.ReturnAssetPropertyEnum.SiteProperty },
        { name: 'priorSite', value: Compliance.ReturnAssetPropertyEnum.PriorSite },
        { name: 'priorSiteProperty', value: Compliance.ReturnAssetPropertyEnum.PriorSiteProperty },
        { name: 'priorSiteName', value: Compliance.ReturnAssetPropertyEnum.PriorSiteName },
        { name: 'disposalAssetNumber', value: Compliance.ReturnAssetPropertyEnum.DisposalAssetNumber },
        { name: 'disposalDescription', value: Compliance.ReturnAssetPropertyEnum.DisposalDescription },
        { name: 'disposalClassification', value: Compliance.ReturnAssetPropertyEnum.DisposalClassification },
        { name: 'assessorAbbr', value: Compliance.ReturnAssetPropertyEnum.AssessorAbbr },
        { name: 't1', value: Compliance.ReturnAssetPropertyEnum.T1 },
        { name: 't2', value: Compliance.ReturnAssetPropertyEnum.T2 },
        { name: 't3', value: Compliance.ReturnAssetPropertyEnum.T3 },
        { name: 't4', value: Compliance.ReturnAssetPropertyEnum.T4 },
        { name: 't5', value: Compliance.ReturnAssetPropertyEnum.T5 },
        { name: 't6', value: Compliance.ReturnAssetPropertyEnum.T6 },
        { name: 't7', value: Compliance.ReturnAssetPropertyEnum.T7 },
        { name: 't8', value: Compliance.ReturnAssetPropertyEnum.T8 },
        { name: 't9', value: Compliance.ReturnAssetPropertyEnum.T9 },
        { name: 't10', value: Compliance.ReturnAssetPropertyEnum.T10 },
        { name: 't11', value: Compliance.ReturnAssetPropertyEnum.T11 },
        { name: 't12', value: Compliance.ReturnAssetPropertyEnum.T12 },
        { name: 't13', value: Compliance.ReturnAssetPropertyEnum.T13 },
        { name: 't14', value: Compliance.ReturnAssetPropertyEnum.T14 },
        { name: 't15', value: Compliance.ReturnAssetPropertyEnum.T15 },
        { name: 't16', value: Compliance.ReturnAssetPropertyEnum.T16 },
        { name: 't17', value: Compliance.ReturnAssetPropertyEnum.T17 },
        { name: 't18', value: Compliance.ReturnAssetPropertyEnum.T18 },
        { name: 't19', value: Compliance.ReturnAssetPropertyEnum.T19 },
        { name: 't20', value: Compliance.ReturnAssetPropertyEnum.T20 },
        { name: 't20', value: Compliance.ReturnAssetPropertyEnum.T20 },
        { name: 't21', value: Compliance.ReturnAssetPropertyEnum.T21 },
        { name: 't22', value: Compliance.ReturnAssetPropertyEnum.T22 },
        { name: 't23', value: Compliance.ReturnAssetPropertyEnum.T23 },
        { name: 't24', value: Compliance.ReturnAssetPropertyEnum.T24 },
        { name: 't25', value: Compliance.ReturnAssetPropertyEnum.T25 },
        { name: 't26', value: Compliance.ReturnAssetPropertyEnum.T26 },
        { name: 't27', value: Compliance.ReturnAssetPropertyEnum.T27 },
        { name: 't28', value: Compliance.ReturnAssetPropertyEnum.T28 },
        { name: 't29', value: Compliance.ReturnAssetPropertyEnum.T29 },
        { name: 't30', value: Compliance.ReturnAssetPropertyEnum.T30 },
        { name: 'n1', value: Compliance.ReturnAssetPropertyEnum.N1 },
        { name: 'n2', value: Compliance.ReturnAssetPropertyEnum.N2 },
        { name: 'n3', value: Compliance.ReturnAssetPropertyEnum.N3 },
        { name: 'n4', value: Compliance.ReturnAssetPropertyEnum.N4 },
        { name: 'n5', value: Compliance.ReturnAssetPropertyEnum.N5 },
        { name: 'n6', value: Compliance.ReturnAssetPropertyEnum.N6 },
        { name: 'n7', value: Compliance.ReturnAssetPropertyEnum.N7 },
        { name: 'n8', value: Compliance.ReturnAssetPropertyEnum.N8 },
        { name: 'n9', value: Compliance.ReturnAssetPropertyEnum.N9 },
        { name: 'n10', value: Compliance.ReturnAssetPropertyEnum.N10 },
        { name: 'd1', value: Compliance.ReturnAssetPropertyEnum.D1 },
        { name: 'd2', value: Compliance.ReturnAssetPropertyEnum.D2 },
        { name: 'd3', value: Compliance.ReturnAssetPropertyEnum.D3 },
        { name: 'd4', value: Compliance.ReturnAssetPropertyEnum.D4 },
        { name: 'd5', value: Compliance.ReturnAssetPropertyEnum.D5 },
        { name: 'd6', value: Compliance.ReturnAssetPropertyEnum.D6 },
        { name: 'd7', value: Compliance.ReturnAssetPropertyEnum.D7 },
        { name: 'd8', value: Compliance.ReturnAssetPropertyEnum.D8 },
        { name: 'd9', value: Compliance.ReturnAssetPropertyEnum.D9 },
        { name: 'd10', value: Compliance.ReturnAssetPropertyEnum.D10 },
        { name: 'createDate', value: Compliance.ReturnAssetPropertyEnum.CreateDate },
    ];

    private _lastFilterUsedInTotals: string;
    lastFetchedTotals: Compliance.ReturnAssetSearchTotalsModel;

    protected canGetRows(): boolean {
        return true;
    }

    protected async getRowsInternal(params: IGetRowsParams): Promise<AgGridDataSourceResult> {
        const searchParams = this.getSearchParamsWithoutPagination();
        const searchParamsString = JSON.stringify(searchParams);
        const fetchTotals: boolean = !this.lastFetchedTotals || this._lastFilterUsedInTotals != searchParamsString;

        this._lastFilterUsedInTotals = searchParamsString;

        if (fetchTotals) {
            searchParams.includeTotals = true;
        }

        searchParams.pagination = {
            skip: params.startRow,
            take: params.endRow - params.startRow,
        };

        const result = await lastValueFrom(
            this._returnAssetRepository.getListByFilingBatch(this._returnService.filingBatchId, searchParams),
        );

        if (fetchTotals) {
            this.lastFetchedTotals = result.totals;
            this._totalsUpdateCallback(this.lastFetchedTotals);
        }

        return {
            rows: result.data,
            totalRows: result.totalRows,
            lastModifiedTimestamp: result.lastModifiedTimestamp,
        };
    }

    clearTotals(): void {
        this._lastFilterUsedInTotals = '';
    }

    getSearchParamsWithoutPagination(): Compliance.ReturnAssetSearchModel {
        const getPriorReturnFromAssetList = this._returnService.filingBatch.getPriorReturnFromAssetList;

        const searchModel: Compliance.ReturnAssetSearchModel = {
            columnFilters: this.getColumnFilters(this._propertyMap),
            sortColumns: this.getSortColumns(this._propertyMap),
            formRevisionIds: this._returnService.sharedState.formRevisionId
                ? [this._returnService.sharedState.formRevisionId]
                : [],
            parcelIds: this._returnService.sharedState.returns.map((x) => x.parcelId),
            assessorIds: getPriorReturnFromAssetList
                ? []
                : this._returnAssetsService.sharedState.assessorFactorsFilter.assessorIds || [],
            formRevisionScheduleIds: this._dataSourceParams.formRevisionScheduleId
                ? [this._dataSourceParams.formRevisionScheduleId]
                : [],
            formFactorTableId: null,
            age: null,
            priorReturnStatuses: this._dataSourceParams.priorReturnStatuses || [],
            scheduleGroupType: Compliance.ScheduleGroupTypeEnum.Unrestricted,
            priorScheduleGroupType: Compliance.ScheduleGroupTypeEnum.Unrestricted,
            selectedRows: null,
            includeTotals: false,
            includeOnlyTotals: false,
            includeMergedParcels: this._returnService.isConsolidatedReturn,
            includeUnassigned: false,
            includeDisposed: true,
        };

        if (
            this._dataSourceParams.priorReturnStatuses.findIndex(
                (x) => x === Compliance.ReturnAssetPriorReturnStatusEnum.Retired,
            ) !== -1 ||
            this._dataSourceParams.priorReturnStatuses.findIndex(
                (x) => x === Compliance.ReturnAssetPriorReturnStatusEnum.TransferOut,
            ) !== -1
        ) {
            if (this._dataSourceParams.targetNonReportableSchedule && this._dataSourceParams.targetReportableSchedule) {
                searchModel.priorScheduleGroupType = Compliance.ScheduleGroupTypeEnum.Unrestricted;
            } else if (this._dataSourceParams.targetNonReportableSchedule) {
                searchModel.priorScheduleGroupType = Compliance.ScheduleGroupTypeEnum.NonReportable;
            } else if (this._dataSourceParams.targetReportableSchedule) {
                searchModel.priorScheduleGroupType = Compliance.ScheduleGroupTypeEnum.ReportableTaxableNotTaxable;
            } else {
                searchModel.priorScheduleGroupType = Compliance.ScheduleGroupTypeEnum.OnlyNotAssignedToASchedule;
            }
        } else {
            if (this._dataSourceParams.scheduleGroupType >= 0) {
                searchModel.scheduleGroupType = this._dataSourceParams.scheduleGroupType;
            } else {
                if (this._dataSourceParams.targetNonReportableSchedule) {
                    searchModel.scheduleGroupType = Compliance.ScheduleGroupTypeEnum.NonReportable;
                }

                if (this._dataSourceParams.targetReportableSchedule) {
                    searchModel.scheduleGroupType = Compliance.ScheduleGroupTypeEnum.ReportableTaxableNotTaxable;
                }
            }
        }

        return searchModel;
    }

    async getRowIdsInternal(startIndex: number, endIndex: number): Promise<Compliance.QueryResultModel<number>> {
        const searchParams = this.getSearchParamsWithoutPagination();
        searchParams.pagination = {
            skip: startIndex,
            take: endIndex - startIndex + 1,
        };

        return await lastValueFrom(
            this._returnAssetRepository.getRowIdsByFilingBatch(this._returnService.filingBatchId, searchParams),
        );
    }
}
